// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "monaco" + "." + "01de954941a2b4b162bd" + ".js";
};